/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = window.L = require('leaflet/dist/leaflet-src');




//////////////////
// WEBPACK FOOTER
// ./~/mapbox.js/src/leaflet.js
// module id = 584
// module chunks = 49